import React, { useEffect, useState } from "react";
import { GlobalState } from "contexts/GlobalState";
import { ReactRegisterModal } from "../RegisterForm/components/ReactRegisterModal";
import "./style.scss";

const LOWEST_SCORE = 450;
const HIGHEST_SCORE = 800;
const COLORS_ORDER = ["green", "gray", "red"];

export const AdmissionReqGraph = (props) => {
  const labels = props.labels;
  const DIFFERENCE = HIGHEST_SCORE - LOWEST_SCORE;

  if (!labels.field_this_year_receipt_threshol || !labels.field_this_year_rejection_thresh) {
    return null;
  }

  const rejectionScore = parseInt(labels.field_this_year_rejection_thresh);
  const acceptanceScore = parseInt(labels.field_this_year_receipt_threshol);
 
  const editScoresPositionToPreventCloseScores = (rejectionScore, acceptanceScore) => {
    if (HIGHEST_SCORE - acceptanceScore < 15) {
      acceptanceScore -= 15;
      if (rejectionScore - LOWEST_SCORE > 30) {
        rejectionScore -= 15;
      }
    }
    if (rejectionScore - LOWEST_SCORE < 15) {
      rejectionScore += 15;
      if (HIGHEST_SCORE - acceptanceScore > 30) {
        acceptanceScore += 15;
      }
    }
    if (acceptanceScore - rejectionScore < 15) {
      if (HIGHEST_SCORE - acceptanceScore < 23) {
        rejectionScore -= 15;
      } else if (rejectionScore - LOWEST_SCORE < 23) {
        acceptanceScore += 15;
      } else {
        acceptanceScore += 8;
        rejectionScore -= 8;
      }
    }
    return [acceptanceScore, rejectionScore];
  }
 
  const [editedAcceptanceScore, editedRejectionScore] = editScoresPositionToPreventCloseScores(rejectionScore, acceptanceScore);

  const redWidthDesktop = (editedRejectionScore - LOWEST_SCORE) / DIFFERENCE * 65.625;
  const redWidthMobile = (editedRejectionScore - LOWEST_SCORE) / DIFFERENCE * 38.75;
  
  const grayWidthDesktop = (editedAcceptanceScore - editedRejectionScore) / DIFFERENCE * 65.625; 
  const grayWidthMobile = (editedAcceptanceScore - editedRejectionScore) / DIFFERENCE * 38.75; 

  const greenWidthDesktop = (HIGHEST_SCORE - editedAcceptanceScore) / DIFFERENCE * 65.625; 
  const greenWidthMobile = (HIGHEST_SCORE - editedAcceptanceScore) / DIFFERENCE * 38.75; 
  
  const graphAcessibilityText = `${labels.rejectionThreshold} ${rejectionScore}, ${labels.acceptanceThreshold} ${acceptanceScore}`;

  return (
    <div className="admission-req-graph">
      <h1 className="ad-req-graph-title" tabIndex="0">{labels.title}</h1>
      <div className="ad-req-graph-content" tabIndex="0" aria-label={graphAcessibilityText}>
        <GraphRect 
          widthsDesktop={[greenWidthDesktop, grayWidthDesktop, redWidthDesktop]}
          widthsMobile={[greenWidthMobile, grayWidthMobile, redWidthMobile]}
        />
        <ScoresRow
          widthsDesktop={[greenWidthDesktop, grayWidthDesktop, redWidthDesktop]}
          widthsMobile={[greenWidthMobile, grayWidthMobile, redWidthMobile]}
          acceptance={acceptanceScore}
          rejection={rejectionScore}
        />
        <GraphInfo labels={labels} />
      </div>
      <WannaKnowAndSignUp labels={labels} />
    </div>
  )
}

const GraphRect = ({widthsDesktop, widthsMobile}) => {
  return (
    <>
      <div className="ad-req-graph-rect d-md-none">
        { widthsMobile.map((singleWidth, index) => (
          <div key={COLORS_ORDER[index]} className={`${COLORS_ORDER[index]}-rect`} style={{width: `${singleWidth}em`}} />
        ))}
      </div>
      <div className="ad-req-graph-rect d-none d-md-block">
        { widthsDesktop.map((singleWidth, index) => (
          <div key={COLORS_ORDER[index]} className={`${COLORS_ORDER[index]}-rect`} style={{width: `${singleWidth}em`}} />
        ))}
      </div>
    </>
  )
} 

const ScoresRow = ({ widthsDesktop, widthsMobile, acceptance, rejection }) => {
  const scoresOrder = [HIGHEST_SCORE, acceptance, rejection, LOWEST_SCORE];

  const calcPaddingForMobileByWidth = (width) => {
      if (width === -1) {
        return 0;
      }
      return (width - 2.8)/1.625;
  }

  const calcPaddingForDesktopByWidth = (width) => {
    if (width === -1) {
      return 0;
    }
    return (width -2.6)/1.5;
  }

  return (
    <>
      <div className="numbers-row d-md-none">
        { scoresOrder.map((score, index) => (
          <span key={score} className="graph-number" style={{paddingLeft: `${calcPaddingForMobileByWidth(widthsMobile[index] ?? -1)}em`}}>
            {score}
          </span>
        ))}
      </div>
      <div className="numbers-row d-none d-md-block">
        { scoresOrder.map((score, index) => (
          <span key={score} className="graph-number" style={{paddingLeft: `${calcPaddingForDesktopByWidth(widthsDesktop[index] ?? 0)}em`}}>
            {score}
          </span>
        ))}
      </div>
    </>
  )
}

const GraphInfo = ({labels}) => {
  const labelsByColorOrder = [labels.greenScoreInfo, labels.grayScoreInfo, labels.redScoreInfo];
  return (
    <div className="graph-info-row">
      { COLORS_ORDER.map((color, index) => (
        <div key={color} className="box-info-wrapper">
          <div className={`${color}-box`} />
          <span className="graph-info-text">
            {labelsByColorOrder[index]}
          </span>
        </div>
      ))}
    </div>
  )
}

const WannaKnowAndSignUp = ({labels}) => {
  const [globalUser, setGlobalUser] = GlobalState("user");
  const [showRegister, setShowRegister] = useState(false);

  const handleAssignToProfile = () => {
   if (globalUser.user) {
     window.location.assign(labels.link_profile);
   } else {
     setShowRegister(true);
   }
 }
  return (
    <>
      <p className="wanna-know" tabIndex="0">
        {labels.question}
      </p>
      <button variant="link"onClick={() => handleAssignToProfile() } className="sign-to-personal">
        {labels.link}
      </button>
      <ReactRegisterModal
        show={ showRegister }
        setShow={setShowRegister}
        labels={labels.RegisterForm.labels}
        lastAction={{
            action:  () => handleAssignToProfile
        }}
      />
    </>
  )
}